import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) || d; } catch { return d; } };

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => load("gh_cart", []).map((i) => ({ ...i, lineKey: i.lineKey || `${i.id}::${i.recipient || ""}` })));
  const [box, setBox] = useState(() => load("gh_box", null));

  useEffect(() => { localStorage.setItem("gh_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("gh_box", JSON.stringify(box)); }, [box]);

  const addItem = useCallback((product, qty = 1, recipient = null, personalMessage = null, recipientName = null, deliveryPref = null, deliveryAddress = null, color = null) => {
    const lineKey = `${product.id}::${recipient || ""}::${recipientName || ""}::${deliveryPref || ""}::${(deliveryAddress || "").slice(0, 24)}::${color || ""}`;
    setItems((prev) => {
      const ex = prev.find((i) => i.lineKey === lineKey);
      if (ex) return prev.map((i) => i.lineKey === lineKey ? { ...i, quantity: i.quantity + qty, personal_message: personalMessage ?? i.personal_message } : i);
      return [...prev, { lineKey, id: product.id, recipient: recipient || null, recipient_name: recipientName || null, personal_message: personalMessage || null, delivery_pref: deliveryPref || null, delivery_address: deliveryAddress || null, color: color || null, name: product.name, price: product.price, image: product.image, slug: product.slug, product_type: product.product_type || "box", quantity: qty }];
    });
  }, []);
  const updateQty = useCallback((lineKey, quantity) => setItems((prev) => prev.map((i) => i.lineKey === lineKey ? { ...i, quantity: Math.max(1, quantity) } : i)), []);
  const removeItem = useCallback((lineKey) => setItems((prev) => prev.filter((i) => i.lineKey !== lineKey)), []);
  const setCustomBox = useCallback((b) => setBox(b), []);
  const removeBox = useCallback(() => setBox(null), []);
  const clear = useCallback(() => { setItems([]); setBox(null); }, []);

  const value = useMemo(() => {
    const itemsTotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const boxTotal = box ? box.items.reduce((s, i) => s + i.price, 0) : 0;
    const total = itemsTotal + boxTotal;
    const count = items.reduce((s, i) => s + i.quantity, 0) + (box ? 1 : 0);
    return { items, box, addItem, updateQty, removeItem, setCustomBox, removeBox, clear, total, count, boxTotal, itemsTotal };
  }, [items, box, addItem, updateQty, removeItem, setCustomBox, removeBox, clear]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}
